import React, { useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { userActions } from '../_actions'
import ResetPasswordComponent from '../components/ResetPasswordComponent'

import { Growl } from 'primereact/growl'

function ResetPasswordContainer({ error, success, isResetLoading, resetPasswordChange, resetPasswordValid }) {

  const growl = useRef()

  return (
    <>
      <Growl ref={growl} />
      {isResetLoading && <div className="overlay">
        <div className="lds-ripple"><div></div><div></div></div>
      </div>}
      <ResetPasswordComponent
        success={success}
        error={error}
        resetPasswordChange={resetPasswordChange}
        resetPasswordValid={resetPasswordValid} />
    </>)
}

ResetPasswordContainer.propTypes = {
  error: PropTypes.object,
  success: PropTypes.object,
  resetPasswordValid: PropTypes.func,
  resetPasswordChange: PropTypes.func
}

const mapStateToProps = state => {
  return {
    error: state.users.resetPasswordError,
    success: state.users.resetPasswordSuccess,
    isResetLoading: state.users.isLoading,
    isAdmin: state.users.token
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetPasswordValid: (val) => dispatch(userActions.resetPasswordValid(val)),
    resetPasswordChange: (val) => dispatch(userActions.resetPasswordChange(val))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContainer)
